import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import ConfigProvider from '../../config-provider';
import Balloon from '../../balloon';
import Icon from '../../icon';

const { Tooltip } = Balloon;

class ClusterItem extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    data: PropTypes.shape({
      img: PropTypes.string,
      text: PropTypes.string.isRequired,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
    colorSets: PropTypes.arrayOf(PropTypes.string),
    onClose: PropTypes.func,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    prefix: 'next-',
    onClose: () => {},
    onClick: () => {},
  }

  constructor(props) {
    super(props);
    this.state = {
      hoverClose: false,
    };
  }

  getBgColor = () => {
    const { data, colorSets } = this.props;
    const { text } = data;
    if (typeof text !== 'string' || colorSets.length === 0 || colorSets.length === 1) {
      return '#289ED3';
    }
    const charCode = text.charCodeAt(0);
    const len = colorSets.length;
    const index = charCode % len;
    return colorSets[index];
  }

  onHoverClose = () => {
    this.setState({
      hoverClose: true,
    });
  }

  onLeaveClose = () => {
    this.setState({
      hoverClose: false,
    });
  }

  onClose = (e) => {
    const { onClose, data } = this.props;
    e.stopPropagation();
    onClose(data);
  }

  onClick = () => {
    const { onClick, data } = this.props;
    onClick(data);
  }

  render() {
    const { prefix, data } = this.props;
    const { img, text } = data;
    const { hoverClose } = this.state;
    return (
      <Tooltip
        trigger={
          <div
            className={cls({
              [`${prefix}avatar-cluster-item`]: true,
              [`${prefix}avatar-cluster-item-hover-close`]: hoverClose,
            })}
            onClick={this.onClick}
          >
            {
              img ? <img className={`${prefix}avatar-cluster-item-img`} src={img} />
                : <span className={`${prefix}avatar-cluster-item-text`} style={{ background: this.getBgColor() }}><span className="scale">{text.slice(0, 2)}</span></span>
            }
            <Icon
              type="remove-o-fill"
              size="small"
              className={`${prefix}avatar-cluster-item-close`}
              onClick={this.onClose}
              onMouseEnter={this.onHoverClose}
              onMouseLeave={this.onLeaveClose}
            />
          </div>
        }
      >
        {text}
      </Tooltip>
    );
  }
}

export default ConfigProvider.config(ClusterItem);
